// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.batch-page {
  margin: 0 12px 24px;
}

.batch-summary-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 24px;
  margin: 0 0 14px;
  max-width: 620px;
}

.batch-summary-field {
  min-width: 220px;
}

.batch-tab-shell {
  background: transparent;
}

.batch-tab-strip {
  display: flex;
  align-items: flex-end;
  margin-bottom: 10px;
  border-bottom: 1px solid #cdd8e3;
}

.batch-tab-label {
  padding: 0 12px 8px;
  color: #0b2d71;
  font-size: 14px;
  font-weight: 600;
  border-bottom: 4px solid #0b2d71;
}

.batch-tab-panel {
  padding: 0;
}

.batch-section {
  margin-top: 14px;
  padding: 12px;
  background: #fff;
  border: 1px solid #cdd8e3;
}

.batch-section-compact,
.batch-section:first-child {
  margin-top: 0;
}

.batch-section-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: -12px -12px 12px;
  padding: 6px 12px;
  background: #0b2d71;
  border-bottom: 1px solid #0b2d71;
}

.batch-section-header > .button {
  margin-left: auto;
}

.batch-section-header-batch {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  flex-wrap: nowrap;
}

.batch-section-header-batch .batch-section-title {
  justify-self: start;
  text-align: left;
}

.batch-header-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.batch-section-title,
.batch-editor-title {
  margin: 0 0 12px;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
}

.batch-section-header .batch-section-title {
  margin: 0;
}

.batch-section-note,
.batch-warning-banner {
  margin: 12px 0 0;
}

.batch-section-body {
  min-width: 0;
}

.batch-tests-list {
  display: grid;
  gap: 8px;
  max-width: 360px;
}

.batch-test-row {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #0f172a;
}

.batch-test-row-locked {
  color: #475569;
}

.batch-test-status {
  color: #475569;
  font-size: 0.84rem;
}

.batch-test-row > input[type='checkbox'],
.batch-inline-checkbox > input[type='checkbox'] {
  flex: 0 0 auto;
  width: 16px;
  height: 16px;
  margin: 0;
  accent-color: #0b2d71;
}

.batch-inline-row,
.batch-action-row,
.batch-editor-footer,
.batch-editor-notes {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 12px;
}

.batch-inline-row + .batch-inline-row,
.batch-inline-row + .batch-section-note,
.batch-table-wrap + .batch-editor-panel,
.batch-editor-panel + .batch-action-row {
  margin-top: 12px;
}

.batch-action-row {
  margin-top: 12px;
}

.batch-action-row-centered {
  justify-content: center;
}

.batch-action-stack {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  text-align: center;
}

.batch-inline-label {
  color: #0f172a;
  font-weight: 600;
}

.batch-inline-checkbox {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.batch-inline-input {
  width: 72px;
  min-width: 72px;
}

.batch-inline-input-volume {
  width: 100%;
  max-width: 130px;
}

.batch-inline-input-wide {
  width: 96px;
  min-width: 96px;
}

.batch-foamer-row {
  align-items: flex-start;
}

.batch-foamer-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 22px;
  max-width: 680px;
}

.batch-warning-banner {
  color: #b91c1c;
  font-size: 0.92rem;
  font-weight: 700;
}

.batch-table-wrap {
  overflow-x: auto;
}

.batch-measure-table {
  min-width: 780px;
}

.batch-measure-table th,
.batch-measure-table td {
  text-align: center;
  vertical-align: middle;
}

.batch-measure-table tbody tr {
  height: 38px;
}

.batch-measure-table .batch-name-col,
.batch-measure-table .batch-name-cell {
  text-align: left;
}

.batch-flag-col,
.batch-flag-cell {
  width: 25px;
  min-width: 25px;
  text-align: center;
}

.batch-fluid-loss-flag {
  color: #dc2626;
  font-size: 1.15rem;
  font-weight: 700;
  line-height: 1;
}

.batch-material-name {
  color: #0f172a;
}

.batch-material-name-after-blend {
  font-weight: 700;
}

.batch-value-with-indicators {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
}

.batch-table-readonly-input {
  flex: 0 0 auto;
  padding: 0.25rem 0.4rem;
  text-align: center;
  pointer-events: none;
}

.batch-table-readonly-input-weight {
  width: 80px;
  min-width: 80px;
}

.batch-table-readonly-input-container {
  width: 120px;
  min-width: 120px;
}

.batch-table-display-container {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 120px;
  max-width: 128px;
  min-height: 24px;
  padding: 0 0.35rem;
  color: #495057;
  text-align: center;
  white-space: nowrap;
}

.batch-container-deleted {
  border: 1px solid #dc2626 !important;
  box-shadow: inset 0 0 0 1px #fecaca;
}

.batch-field-display {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 31px;
  width: 100%;
  padding: 0.25rem 0.5rem;
  border: 1px solid #ced4da;
  background: #e9ecef;
  border-radius: 0.2rem;
  color: #495057;
  font-size: 0.875rem;
  text-align: center;
  font-family: 'GothamNarrowBook', sans-serif;
}

.batch-disposed-note {
  color: #b91c1c;
  font-weight: 700;
}

.batch-indicator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  font-size: 0.72rem;
  font-weight: 700;
}

.batch-indicator-button {
  background: transparent;
  border: 0;
  cursor: pointer;
  font: inherit;
  padding: 0;
}

.batch-indicator-warning {
  color: #991b1b;
  background: #fee2e2;
  cursor: default;
}

.batch-indicator-note {
  color: #1d4ed8;
  background: #dbeafe;
}

.batch-indicator-note-accepted {
  color: #166534;
  background: #dcfce7;
  box-shadow: inset 0 0 0 1px #86efac;
}

.batch-measure-row-active {
  background: #f4f8ff;
}

.batch-editor-panel {
  padding: 12px;
  border: 1px solid #d9e2ec;
  background: #f8fafc;
}

.batch-editor-title {
  margin: 0 0 12px;
  color: #0b2d71;
  font-size: 14px;
}

.batch-editor-grid,
.batch-foam-grid {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
}

.batch-editor-notes {
  align-items: flex-start;
}

.batch-inline-alert {
  color: #92400e;
  font-size: 0.92rem;
  font-weight: 600;
}

.batch-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-top: 18px;
}

.batch-footer-actions {
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 0;
  text-align: center;
}

.batch-footer-actions .button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

@media (max-width: 768px) {
  .batch-page {
    margin-left: 0;
    margin-right: 0;
  }

  .batch-summary-row {
    max-width: none;
  }

  .batch-inline-row,
  .batch-action-row,
  .batch-editor-footer,
  .batch-editor-notes {
    align-items: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/slurry-batch-details/slurry-batch-details.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,qBAAqB;AACvB;;AAEA;;;;EAIE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,SAAS;EACT,2DAA2D;AAC7D;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;IAIE,uBAAuB;EACzB;AACF","sourcesContent":[".batch-page {\n  margin: 0 12px 24px;\n}\n\n.batch-summary-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px 24px;\n  margin: 0 0 14px;\n  max-width: 620px;\n}\n\n.batch-summary-field {\n  min-width: 220px;\n}\n\n.batch-tab-shell {\n  background: transparent;\n}\n\n.batch-tab-strip {\n  display: flex;\n  align-items: flex-end;\n  margin-bottom: 10px;\n  border-bottom: 1px solid #cdd8e3;\n}\n\n.batch-tab-label {\n  padding: 0 12px 8px;\n  color: #0b2d71;\n  font-size: 14px;\n  font-weight: 600;\n  border-bottom: 4px solid #0b2d71;\n}\n\n.batch-tab-panel {\n  padding: 0;\n}\n\n.batch-section {\n  margin-top: 14px;\n  padding: 12px;\n  background: #fff;\n  border: 1px solid #cdd8e3;\n}\n\n.batch-section-compact,\n.batch-section:first-child {\n  margin-top: 0;\n}\n\n.batch-section-header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin: -12px -12px 12px;\n  padding: 6px 12px;\n  background: #0b2d71;\n  border-bottom: 1px solid #0b2d71;\n}\n\n.batch-section-header > .button {\n  margin-left: auto;\n}\n\n.batch-section-header-batch {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  flex-wrap: nowrap;\n}\n\n.batch-section-header-batch .batch-section-title {\n  justify-self: start;\n  text-align: left;\n}\n\n.batch-header-actions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.batch-section-title,\n.batch-editor-title {\n  margin: 0 0 12px;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.batch-section-header .batch-section-title {\n  margin: 0;\n}\n\n.batch-section-note,\n.batch-warning-banner {\n  margin: 12px 0 0;\n}\n\n.batch-section-body {\n  min-width: 0;\n}\n\n.batch-tests-list {\n  display: grid;\n  gap: 8px;\n  max-width: 360px;\n}\n\n.batch-test-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #0f172a;\n}\n\n.batch-test-row-locked {\n  color: #475569;\n}\n\n.batch-test-status {\n  color: #475569;\n  font-size: 0.84rem;\n}\n\n.batch-test-row > input[type='checkbox'],\n.batch-inline-checkbox > input[type='checkbox'] {\n  flex: 0 0 auto;\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  accent-color: #0b2d71;\n}\n\n.batch-inline-row,\n.batch-action-row,\n.batch-editor-footer,\n.batch-editor-notes {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px 12px;\n}\n\n.batch-inline-row + .batch-inline-row,\n.batch-inline-row + .batch-section-note,\n.batch-table-wrap + .batch-editor-panel,\n.batch-editor-panel + .batch-action-row {\n  margin-top: 12px;\n}\n\n.batch-action-row {\n  margin-top: 12px;\n}\n\n.batch-action-row-centered {\n  justify-content: center;\n}\n\n.batch-action-stack {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  text-align: center;\n}\n\n.batch-inline-label {\n  color: #0f172a;\n  font-weight: 600;\n}\n\n.batch-inline-checkbox {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.batch-inline-input {\n  width: 72px;\n  min-width: 72px;\n}\n\n.batch-inline-input-volume {\n  width: 100%;\n  max-width: 130px;\n}\n\n.batch-inline-input-wide {\n  width: 96px;\n  min-width: 96px;\n}\n\n.batch-foamer-row {\n  align-items: flex-start;\n}\n\n.batch-foamer-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 22px;\n  max-width: 680px;\n}\n\n.batch-warning-banner {\n  color: #b91c1c;\n  font-size: 0.92rem;\n  font-weight: 700;\n}\n\n.batch-table-wrap {\n  overflow-x: auto;\n}\n\n.batch-measure-table {\n  min-width: 780px;\n}\n\n.batch-measure-table th,\n.batch-measure-table td {\n  text-align: center;\n  vertical-align: middle;\n}\n\n.batch-measure-table tbody tr {\n  height: 38px;\n}\n\n.batch-measure-table .batch-name-col,\n.batch-measure-table .batch-name-cell {\n  text-align: left;\n}\n\n.batch-flag-col,\n.batch-flag-cell {\n  width: 25px;\n  min-width: 25px;\n  text-align: center;\n}\n\n.batch-fluid-loss-flag {\n  color: #dc2626;\n  font-size: 1.15rem;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.batch-material-name {\n  color: #0f172a;\n}\n\n.batch-material-name-after-blend {\n  font-weight: 700;\n}\n\n.batch-value-with-indicators {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  width: 100%;\n}\n\n.batch-table-readonly-input {\n  flex: 0 0 auto;\n  padding: 0.25rem 0.4rem;\n  text-align: center;\n  pointer-events: none;\n}\n\n.batch-table-readonly-input-weight {\n  width: 80px;\n  min-width: 80px;\n}\n\n.batch-table-readonly-input-container {\n  width: 120px;\n  min-width: 120px;\n}\n\n.batch-table-display-container {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 120px;\n  max-width: 128px;\n  min-height: 24px;\n  padding: 0 0.35rem;\n  color: #495057;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.batch-container-deleted {\n  border: 1px solid #dc2626 !important;\n  box-shadow: inset 0 0 0 1px #fecaca;\n}\n\n.batch-field-display {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 31px;\n  width: 100%;\n  padding: 0.25rem 0.5rem;\n  border: 1px solid #ced4da;\n  background: #e9ecef;\n  border-radius: 0.2rem;\n  color: #495057;\n  font-size: 0.875rem;\n  text-align: center;\n  font-family: 'GothamNarrowBook', sans-serif;\n}\n\n.batch-disposed-note {\n  color: #b91c1c;\n  font-weight: 700;\n}\n\n.batch-indicator {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n\n.batch-indicator-button {\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n  font: inherit;\n  padding: 0;\n}\n\n.batch-indicator-warning {\n  color: #991b1b;\n  background: #fee2e2;\n  cursor: default;\n}\n\n.batch-indicator-note {\n  color: #1d4ed8;\n  background: #dbeafe;\n}\n\n.batch-indicator-note-accepted {\n  color: #166534;\n  background: #dcfce7;\n  box-shadow: inset 0 0 0 1px #86efac;\n}\n\n.batch-measure-row-active {\n  background: #f4f8ff;\n}\n\n.batch-editor-panel {\n  padding: 12px;\n  border: 1px solid #d9e2ec;\n  background: #f8fafc;\n}\n\n.batch-editor-title {\n  margin: 0 0 12px;\n  color: #0b2d71;\n  font-size: 14px;\n}\n\n.batch-editor-grid,\n.batch-foam-grid {\n  display: grid;\n  gap: 12px;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n}\n\n.batch-editor-notes {\n  align-items: flex-start;\n}\n\n.batch-inline-alert {\n  color: #92400e;\n  font-size: 0.92rem;\n  font-weight: 600;\n}\n\n.batch-footer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  margin-top: 18px;\n}\n\n.batch-footer-actions {\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-top: 0;\n  text-align: center;\n}\n\n.batch-footer-actions .button:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n@media (max-width: 768px) {\n  .batch-page {\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  .batch-summary-row {\n    max-width: none;\n  }\n\n  .batch-inline-row,\n  .batch-action-row,\n  .batch-editor-footer,\n  .batch-editor-notes {\n    align-items: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
